import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-go-overview-step-two',
    imports: [],
    templateUrl: './go-overview-step-two.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['../../go-overview.component.scss'],
})
export class GoOverviewStepTwoComponent {}
